import React from 'react';

const MediaGenres = ({ genres }) => {
  if (!genres || genres.length === 0) return null;

  return (
    <section className="genres-section">
      <h2>
        <img src="/static/icons/tags-solid.svg" alt="Genres" className="section-icon icon" />
        Genres
      </h2>
      <div className="tag-container">
        {genres.map((g, i) => (
          <span className="tag" key={i}>
            {g}
          </span>
        ))}
      </div>
    </section>
  );
};

export default MediaGenres;